module.exports = __webpack_public_path__ + "static/[edgeinnovationcenter.com][218]8-1-1018052424a79efd5938c640cab620d8.jpg";